export default {
  NODE_ENV: `${process.env.NODE_ENV}`,
  SDK_API_URL: `${process.env.SDK_API_URL}`,
  WEB_URL: `${process.env.WEB_URL}`,
  DOMAIN: `${process.env.DOMAIN}`,
  STRIPE_CLIENT_ID: `${process.env.STRIPE_CLIENT_ID}`,
  TL_API_KEY: `${process.env.TL_API_KEY}`
};



// WEBPACK FOOTER //
// ./src/config.js